module.exports = __webpack_public_path__ + "static/media/banner.a7c8cdfc.jpg";